import { IUser } from '@contexts/AuthContext/type';

export const getAccessUseful = (slug: string, user: IUser) => {
  const userAccess = user?.data?.access?.useful;
  return !!userAccess && userAccess.some(obj => obj.slug === slug);
};